import SharedCalendarsOptionViewState from './schema/SharedCalendarsOptionViewState';
import { createStore } from 'satcheljs';

let initialSharedCalendarsOptionViewState: SharedCalendarsOptionViewState = {
    calendars: [],
    initialState: {},
    currentState: {},
    calendarsPublish: [],
};

export default createStore<SharedCalendarsOptionViewState>(
    'SharedCalendars',
    initialSharedCalendarsOptionViewState
);
